import React from "react";
import {Activity, User} from "myfitworld-model";
import {Typography} from "@material-ui/core";
import { Notifications } from "@material-ui/icons";
import { useIntl } from "react-intl";
import chatMessages from '../chat/messages';
import { BaseNotificationView } from "./BaseNotificationView";
import {linkify} from "../../utils/renderTextWithLinks";
import {useMfwThemeProvider} from "myfitworld-utils";

interface TrainerNotificationViewProps {
  activity: Activity;
  client?: User;
}

const TrainerNotificationView: React.FC<TrainerNotificationViewProps> = ({activity, client}) => {
  const { formatMessage } = useIntl();
  const {theme} = useMfwThemeProvider();

  return (
    <BaseNotificationView
      activity={activity}
      client={client}
      headerIcon={<Notifications color="primary" style={{width: 17, height: 17}}/>}
      headerLabel={formatMessage(chatMessages.trainer_notification).toUpperCase()}
    >
      <Typography
        component="div"
        dangerouslySetInnerHTML={{
          __html: linkify(activity.text || "", theme.theme.primary)
        }}
      />
    </BaseNotificationView>
  );
};

export default TrainerNotificationView;
